// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/downed-aircraft-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/downed-aircraft-procedures/downed-aircraft-procedures.js';

mount([g0]);
